import React, { Component } from 'react';
import { TextOnly } from '../../templates';
import { withLanguageContext } from '../../../utils/LanguageContext';

import './styles.css';

/**
 * The GetInTouchQrView of the landing page.
 *
 * @typedef {Object} Props
 * @prop {Object} [content]
 *
 * @augments {Component<Props>}
 */
class GetInTouchQrView extends Component {
	render () {
		const { content, heading } =
			this.props.content.qrLandingPage.getInTouch;
		return (
			<TextOnly
				className='GetInTouchQrView'
				{...{
					content,
					heading,
				}}
			/>
		);
	}
}

export default withLanguageContext(GetInTouchQrView);



// WEBPACK FOOTER //
// ./src/components/views/GetInTouchQrView/GetInTouchQrView.js